import React from 'react';

import cx from 'classnames';

import Button from 'components/shared/Button';

import s from './index.module.css';

export function Actions(props) {
  const { activeType, handleSetType, types = [], isEdit, className } = props;

  return (
    <div className={cx(s.actions, className, 'custom-add-flights-actions')}>
      {types.map((type) => (
        <Button
          key={type}
          type={type === activeType ? undefined : 'default'}
          htmlType="button"
          onClick={() => handleSetType(type)}
          disabled={isEdit}
        >
          {type}
        </Button>
      ))}
    </div>
  );
}
